// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604290803/js/" + chunkId + "." + {"44":"efca52c7","225":"708c8196","481":"7d9ddfba","486":"24edf03e","770":"92e79039"}[chunkId] + ".0.5611987285875035.chunk.js";
};